<div class="dialog-container" *ngIf="form">
    <!-- Header -->
    <div class="header-container">
        <div class="header-title">
            {{ isEdit ? 'Edit ethnicity' : 'Add ethnicity' }}
        </div>
        <div class="close-icon" (click)="onCancel()">
            <img src="assets/images/cross-icon.svg" class="cross-icon" alt="Close" />
        </div>
    </div>

    <!-- Form -->
    <form [formGroup]="form" (ngSubmit)="onSave()">
        <div class="form-content">
            <!-- Ethnicity Name Field -->
            <div class="form-group">
                <app-input 
                    context="Normal" 
                    class="form-item" 
                    label="Ethnicity name" 
                    [required]="true"
                    placeholder="Enter ethnicity name" 
                    type="text" 
                    [control]="form.get('ethnicityName')"
                    [customErrorMessages]="customErrorMessages.ethnicityName">
                </app-input>
            </div>

            <!-- Color Picker Field -->
            <div class="form-group color-picker-group">
                <label class="color-label">Select color</label>
                <div class="color-picker-container">
                    <input 
                        type="color" 
                        formControlName="color"
                        class="color-input"
                        (change)="onColorChange($event)">
                    <!-- <div class="color-preview" [style.background-color]="selectedColor || '#000000'"></div> -->
                </div>
                <div class="color-value">{{ selectedColor || '#000000' }}</div>
            </div>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
            <button 
                type="button" 
                class="cancel-button" 
                (click)="onCancel()" 
                [disabled]="loading || isProcessing">
                Cancel
            </button>
            <button 
                type="submit" 
                class="submit-button" 
                [disabled]="loading || isProcessing">
                <span *ngIf="!loading && !isProcessing">
                    Submit
                </span>
                <span *ngIf="loading || isProcessing">
                    Submiting...
                </span>
            </button>
        </div>
    </form>
</div>